var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isApproved)?_c('gl-icon',{attrs:{"name":"check","variant":"success","size":16}}):_c('div',{staticClass:"square s16"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }